import { render, staticRenderFns } from "./UpdateVideoModal.vue?vue&type=template&id=cb705b40"
import script from "./UpdateVideoModal.vue?vue&type=script&lang=js"
export * from "./UpdateVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports